import { useMemo } from 'react';
import { ExitToApp } from '@mui/icons-material';

import { QuizPage } from '../../pages';
import { useLocalize } from '../../hooks';
import { NavLabels, NavRoutes } from './const';
import { CoursePage, CoursesPage } from '../../pages';
// import { OverviewPage, CertificatesPage } from '../../pages';
import type { MenuItem } from '../Layouts';

const useAuthenticatedMenuItems = (logout: Function): MenuItem[] => {
  const { t } = useLocalize();

  return useMemo(
    () => [
      {
        url: `${NavRoutes.COURSES}/:id`,
        component: CoursePage,
      },
      // {
      //   url: NavRoutes.CERTIFICATES,
      //   text: t(NavLabels.Certificates),
      //   component: CertificatesPage,
      // },
      {
        url: NavRoutes.COURSES,
        text: t(NavLabels.Courses),
        component: CoursesPage,
      },
      // {
      //   url: NavRoutes.OVERVIEW,
      //   text: t(NavLabels.Overview),
      //   component: OverviewPage,
      // },
      {
        url: `${NavRoutes.QUIZ}/:enrollmentId/:stepId`,
        component: QuizPage,
      },
      {
        text: t(NavLabels.Logout),
        onClick: () =>
          logout({ logoutParams: { returnTo: window.location.origin } }),
        icon: <ExitToApp />,
      },
    ],
    [t, logout]
  );
};

export const getUnauthMenuItems = (loginWithRedirect: Function): MenuItem[] => {
  return [
    {
      text: 'Login',
      onClick: () => loginWithRedirect(),
      icon: null,
    },
  ];
};

export const useRoutes = (
  login: Function,
  logout: Function,
  isAuthenticated: boolean
) => {
  const authMenuItems = useAuthenticatedMenuItems(logout);
  const unauthMenuItems = useMemo(() => getUnauthMenuItems(login), [login]);

  const menuItems = isAuthenticated ? authMenuItems : unauthMenuItems;

  const [publicRoutes, privateRoutes] = useMemo(() => {
    const itemsWithRoutes = menuItems.filter(i => i.component && i.url);

    return [
      itemsWithRoutes.filter(i => i.isPublic),
      itemsWithRoutes.filter(i => !i.isPublic),
    ];
  }, [menuItems]);

  return { publicRoutes, privateRoutes, menuItems };
};
